const Graph = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.688 7.19995C13.688 6.64767 14.1357 6.19995 14.688 6.19995H21.6C22.1523 6.19995 22.6 6.64767 22.6 7.19995V13.8461C22.6 14.3984 22.1523 14.8461 21.6 14.8461C21.0477 14.8461 20.6 14.3984 20.6 13.8461V9.54877L13.0771 16.7823C12.69 17.1545 12.078 17.1545 11.6909 16.7823L7.77602 13.018L3.09313 17.5208C2.69503 17.9036 2.06199 17.8912 1.67919 17.4931C1.2964 17.095 1.30881 16.4619 1.70692 16.0791L7.08292 10.9099C7.47003 10.5377 8.08202 10.5377 8.46913 10.9099L12.384 14.6742L19.1172 8.19995H14.688C14.1357 8.19995 13.688 7.75224 13.688 7.19995Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Graph;
